import { render, staticRenderFns } from "./ActComponent.vue?vue&type=template&id=741fcb3f&scoped=true"
import script from "./ActComponent.vue?vue&type=script&lang=js"
export * from "./ActComponent.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=741fcb3f&prod&scoped=true&lang=css&external"
import style1 from "./ActComponent.vue?vue&type=style&index=1&id=741fcb3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741fcb3f",
  null
  
)

export default component.exports